export default "__VITE_ASSET__CxZWyCIX__"